export enum InvoicePossibleActionType {
    EDIT = 'EDIT',
    MARK_AS_PAID = 'MARK_AS_PAID',
}
